//
// ┌─────────────────────┐
// │ DO NOT EDIT BY HAND │
// └─────────────────────┘
//
// Generated by build.mjs in zinnia-icons
//
import { mapPropsToSvgProps, Props } from "../utils";
function IconActionZapDetails(iconProps: Props) {
  const props = mapPropsToSvgProps(iconProps);
  return <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M20 8V6.59L15.41 2H4V22H20V10H18V20H6V4H14V8H20Z" fill="currentColor" /><path d="M10.7502 18.8583L15.5586 13.1292H13.2502V9.06665L8.44189 14.7958H10.7502V18.8583Z" fill="currentColor" /></svg>;
}
export default IconActionZapDetails;